var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.file.categoria
          ? "Referencias Expediente " +
            _vm.file.categoria +
            "-" +
            _vm.file.numeroExt
          : "Referencias Expediente " + _vm.file.numero,
        "hide-footer": "",
        centered: "",
        size: "lg"
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", [
        _c("div", { staticClass: "row mb-3" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "py-2 box-activities" },
              [
                _c(
                  "vs-table",
                  {
                    staticClass: "wrap-table",
                    attrs: {
                      stripe: "",
                      data: _vm.references || [],
                      noDataText: "No hay referencias aun"
                    }
                  },
                  [
                    _c("template", { slot: "header" }),
                    _c(
                      "template",
                      { slot: "thead" },
                      [
                        _c("vs-th", [_vm._v(" Tipo Doc. ")]),
                        _c("vs-th", [_vm._v(" Número / Folio ")]),
                        _vm.showDate
                          ? _c("vs-th", [_vm._v(" Fecha ")])
                          : _vm._e(),
                        _c("vs-th", [_vm._v(" Ver referencia ")])
                      ],
                      1
                    ),
                    [
                      _c(
                        "tbody",
                        _vm._l(_vm.referencesByType, function(
                          reference,
                          index
                        ) {
                          return _c(
                            "vs-tr",
                            { key: index },
                            [
                              !_vm.isConvention
                                ? _c("vs-td", [
                                    reference.febosId
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.findTypeDocument(
                                                  reference.tipoCodigo
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      : _vm._e(),
                                    !reference.febosId
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.findLabelDocument(
                                                  reference.tipoCodigo
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm.isConvention
                                ? _c("vs-td", [
                                    reference.type === "referenciadosTipoDnt"
                                      ? _c("div", [_vm._v(" Documento ")])
                                      : _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.findTypeDocument(
                                                  reference.tipoCodigo
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                  ])
                                : _vm._e(),
                              _c("vs-td", [
                                _vm._v(
                                  " " + _vm._s(reference.folioReferencia) + " "
                                )
                              ]),
                              _vm.showDate
                                ? _c("vs-td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            reference.fechaEmision
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "vs-td",
                                [
                                  reference.febosId
                                    ? _c("vs-icon", {
                                        staticClass: "ml-5 pl-5 cursor-pointer",
                                        attrs: { size: "22px", icon: "search" },
                                        on: {
                                          click: function($event) {
                                            return _vm.goToReference(
                                              reference.tipoCodigo,
                                              reference.febosId
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ]
                  ],
                  2
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }